import * as vp from 'vopay';

import { useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

const initHook = vopayApi.withApiHook(({ api }) => {
  return function useRailzInventory() {
    const source = axios.CancelToken.source();

    const [inventory, setInventory] = useState<vp.RailzInventoryItem[]>();

    const [, setDataFetchingInfo] = useDataFetchIndicator();

    const fetchInventory = async (requestParams: vp.RailzInventoryRequest) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.railzInventory(requestParams, source);
        setInventory(res.Inventory);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    };
    const reset = () => {
      setInventory(undefined);
    };

    return {
      inventory,
      fetchInventory,
      reset,
    };
  };
});

export default initHook({});
